type Attrs = Record<string, string | number | boolean | ((ev: Event) => void)>;

/** Small DOM builder: attributes (on* = listeners, true = present) and children. */
export function el<K extends keyof HTMLElementTagNameMap>(
	tag: K,
	attrs: Attrs = {},
	...children: Array<Node | string | null>
): HTMLElementTagNameMap[K] {
	const node = document.createElement(tag);
	for (const [name, value] of Object.entries(attrs)) {
		if (typeof value === "function") node.addEventListener(name.slice(2), value);
		else if (value === true) node.setAttribute(name, "");
		else if (value !== false) node.setAttribute(name, String(value));
	}
	for (const child of children) if (child !== null) node.append(child);
	return node;
}

/** Key presses inside text fields belong to the field, not the game. */
export function isTypingTarget(ev: Event): boolean {
	const t = ev.target;
	return (
		t instanceof HTMLTextAreaElement ||
		(t instanceof HTMLInputElement && (t.type === "text" || t.type === "search")) ||
		(t instanceof HTMLElement && t.isContentEditable)
	);
}
